var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPengalamanIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 13.3327C13.222 13.3327 15.8337 10.721 15.8337 7.49935C15.8337 4.27769 13.222 1.66602 10.0003 1.66602C6.77867 1.66602 4.16699 4.27769 4.16699 7.49935C4.16699 10.721 6.77867 13.3327 10.0003 13.3327Z",
    stroke: "#FF9900",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12592 12.5L5.5952 14.4358C5.07158 16.3457 4.80977 17.3006 5.15914 17.8234C5.28158 18.0066 5.44583 18.1537 5.63643 18.2507C6.18029 18.5276 7.02001 18.0901 8.69942 17.215C9.25825 16.9238 9.53767 16.7782 9.8345 16.7466C9.94458 16.7348 10.0554 16.7348 10.1655 16.7466C10.4623 16.7782 10.7417 16.9238 11.3006 17.215C12.98 18.0901 13.8197 18.5276 14.3636 18.2507C14.5542 18.1537 14.7184 18.0066 14.8408 17.8234C15.1902 17.3006 14.9284 16.3457 14.4048 14.4358L13.8741 12.5",
    stroke: "#FF9900",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPengalamanIconOrange);
export default __webpack_public_path__ + "static/media/pengalaman_icon_orange.ac39dd40a226732e870c730f3dca23de.svg";
export { ForwardRef as ReactComponent };